import { useState } from 'react';
import { LinkBadge } from './LinkBadge';

// The team logo on every player profile: a rounded square with a cyan border,
// same size and frame as the player's photo beside it. With onClick (or when
// wrapped in a link) it gets the "opens" badge on its bottom-right corner.
const FRAME = 'w-24 h-24 sm:w-28 sm:h-28 lg:w-32 lg:h-32 flex-shrink-0 rounded-2xl border-2 border-cyan-400/60 bg-white p-2 shadow-xl flex items-center justify-center overflow-hidden';

export const TeamLogoBox = ({ name, logo, onClick, badge = Boolean(onClick), className = '' }) => {
  const [failedSrc, setFailedSrc] = useState(null);

  const box = (
    <span className={`${FRAME} transition-transform group-hover:scale-105`}>
      {logo && failedSrc !== logo ? (
        <img src={logo} alt={name ? `${name} logo` : 'Team logo'} onError={() => setFailedSrc(logo)} className="w-full h-full object-contain" />
      ) : (
        <svg className="w-3/5 h-3/5 text-jp-band" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M12 3L1 9l4 2.18v6L12 21l7-3.82v-6l2-1.09V17h2V9L12 3zm6.82 6L12 12.72 5.18 9 12 5.28 18.82 9zM17 15.99l-5 2.73-5-2.73v-3.72L12 15l5-2.73v3.72z" />
        </svg>
      )}
    </span>
  );

  if (!onClick) {
    return (
      <span className={`group relative inline-flex flex-shrink-0 ${className}`}>
        {box}
        {badge && <LinkBadge className="-bottom-2 -right-2" />}
      </span>
    );
  }

  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={name ? `View ${name} team page` : 'View team page'}
      className={`group relative inline-flex flex-shrink-0 rounded-2xl focus:outline-none focus-visible:ring-2 focus-visible:ring-cyan-400 ${className}`}
    >
      {box}
      {badge && <LinkBadge className="-bottom-2 -right-2" />}
    </button>
  );
};

export default TeamLogoBox;
